<div class="container mat-component-background">
  <h1 mat-dialog-title>{{ data.title }}</h1>
  <div mat-dialog-content [formGroup]="reactivateWithEndDateFormGroup">
    <p>
      {{ data.message }}<br />
      <strong><em>{{ data.data }}</em></strong> <br/>
      <br/>
    </p>
    <mat-form-field appearance="outline">
      <mat-label>End Date</mat-label>
      <input matInput 
        [min]="minEndDate"
        [value]="reactivateWithEndDateFormGroup.controls.reactivateEndDate.value"
        [matDatepicker]="reactivateEndDatePicker" formControlName="reactivateEndDate" class="ng-trim-ignore" />
      <mat-datepicker-toggle matIconSuffix [for]="reactivateEndDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #reactivateEndDatePicker></mat-datepicker>
      <mat-error *ngIf="
                reactivateWithEndDateFormGroup
                  .get('reactivateEndDate')
                  .hasError('required') &&
                reactivateWithEndDateFormGroup.get('reactivateEndDate').touched
              ">
        <span>End date is required</span>
      </mat-error>
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="container-actions">
    <button mat-raised-button (click)="onCancelClick()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onConfirmClick()" cdkFocusInitial>
      {{ data.confirm }}
    </button>
  </div>
</div>